module.exports = __webpack_public_path__ + "media/images/2_3_4-41fecf40736a9c02f79627528efdf672.png";